import { SignIn } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';
import { ROUTE_NAMES } from '@tsgecart/config';
import { clerkAppearance } from '../lib/auth/clerk-appearance.js';
import { resolveSafeReturnPath } from '../lib/auth/safe-redirect.js';

export function SignInPage() {
  const [searchParams] = useSearchParams();
  const returnTo = resolveSafeReturnPath(searchParams.get('redirect'), ROUTE_NAMES.home);

  return (
    <main className="flex min-h-screen items-center justify-center bg-neutral-50 p-4">
      <SignIn
        routing="path"
        path={ROUTE_NAMES.signIn}
        signUpUrl={ROUTE_NAMES.signUp}
        fallbackRedirectUrl={returnTo}
        appearance={clerkAppearance}
      />
    </main>
  );
}
